/*document.addEventListener('DOMContentLoaded', function () {
  var childlinks = document.querySelectorAll('.childlink-links');
  var grandchildLinks = document.querySelectorAll('.grandchildlink-links');

  childlinks.forEach(function (link, index) {
    link.addEventListener('mouseover', function () {
      if (grandchildLinks[index]) grandchildLinks[index].classList.add('active');
    });
    link.addEventListener('mouseout', function () {
      if (grandchildLinks[index]) grandchildLinks[index].classList.remove('active');
    });
  });
});*/

// ***** Remove long bundle items list from cart
/*(function () {
  var CONTAINER_SELECTOR = '.cart__item--properties, [data-cart-item-properties]';

  var HIDE_LABELS = ['Items:', 'OfferId:', 'Bundle:'];

  function normalize(txt) {
    return (txt || '').replace(/\u00A0/g, ' ').trim();
  }

  function boxHasAnyLabel(box) {
    var spans = box.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      if (HIDE_LABELS.indexOf(normalize(spans[i].textContent)) !== -1) {
        return true;
      }
    }
    return false;
  }

  function hideWholeProperties(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var boxes = scope.querySelectorAll(CONTAINER_SELECTOR);
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.style.display === 'none') continue;
      if (boxHasAnyLabel(box)) {
        box.style.display = 'none'; // or box.remove()
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { hideWholeProperties(document); });
  } else {
    hideWholeProperties(document);
  }

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType === 1) hideWholeProperties(n);
      }
      if (m.type === 'characterData' && m.target && m.target.parentElement) {
        var parent = m.target.parentElement.closest(CONTAINER_SELECTOR);
        if (parent) hideWholeProperties(parent);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();*/

// ***** Whatsapp
  document.addEventListener('DOMContentLoaded', function () {
    let timeout;

    const textBubble = document.getElementById('text-bubble');
    const whatsappImage = document.querySelector('#whatsapp-bubble img');

    if (!textBubble || !whatsappImage) return;

    const resetTimer = () => {
        clearTimeout(timeout);

        textBubble.style.opacity = '0';
        textBubble.style.right = '84px';
        textBubble.style.pointerEvents = 'none';

        whatsappImage.classList.remove('expand');

        timeout = setTimeout(() => {
            textBubble.style.opacity = '1';
            textBubble.style.right = '88px';
            textBubble.style.pointerEvents = 'auto';

            whatsappImage.classList.add('expand');

            setTimeout(() => {
                whatsappImage.classList.remove('expand');
            }, 300);

        }, 10000);
    };

    setTimeout(() => {
        whatsappImage.classList.add('expand');

        setTimeout(() => {
            whatsappImage.classList.remove('expand');
        }, 300);

    }, 10000);

    resetTimer();

    window.addEventListener('scroll', resetTimer);
    window.addEventListener('click', resetTimer);
  });

//***** Header hover state + store locator dropdown
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.header-wrapper');
  var menuItems = document.querySelectorAll('.main_menu_item');

  if (header && menuItems.length) {
    menuItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        header.classList.add('active_hover');
      });

      item.addEventListener('mouseleave', function () {
        header.classList.remove('active_hover');
      });
    });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.store-toggle');
    var locator = e.target.closest('.store-locator');
    var dropdown = document.querySelector('.store-dropdown');

    if (toggle && dropdown) {
      dropdown.classList.toggle('open');
      return;
    }

    if (!locator && dropdown) {
      dropdown.classList.remove('open');
    }
  });
});

// Toggle marked mega-menu submenus, including headers reloaded by the theme editor.
document.addEventListener('click', function (event) {
  var toggle = event.target.closest('.custom_header__inline-menu .mega-menu-submenu-toggle');
  if (!toggle) return;

  var submenu = document.getElementById(toggle.getAttribute('aria-controls'));
  if (!submenu) return;

  var expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));
  submenu.hidden = expanded;
});
